import React from 'react';

const Roompopup = () => {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="text-center bg-[#3D6643] text-white rounded-lg py-4 shadow">
        <div className="text-4xl mb-2">🏡</div>
        <h2 className="text-2xl font-bold mb-1">Room Management Overview</h2>
        <p className="text-sm">
          Learn how Stay Cool software helps manage rooms with ease.
        </p>
      </div>

      {/* Room Management Description */}
      <div className="bg-white shadow rounded p-6 border border-gray-200 space-y-4">
        <p className="text-gray-800 text-base leading-relaxed">
          The <span className="font-semibold text-[#3D6643]">Stay Cool Room Management</span> module allows you to organize and manage all your villa or hotel rooms in one centralized system.
        </p>
        <p className="text-gray-800 text-base leading-relaxed">
          You can define custom <span className="font-medium">Room Types</span> like Deluxe, Suite, or Standard, helping categorize your inventory for better filtering and bookings.
        </p>
        <p className="text-gray-800 text-base leading-relaxed">
          Easily assign individual rooms to types, set their availability status (e.g., Available, Booked, Maintenance), and attach related details like room numbers and amenities.
        </p>
        <p className="text-gray-800 text-base leading-relaxed">
          This module ensures streamlined operations by keeping your staff informed about which rooms are ready for guests and which require attention.
        </p>
        <p className="text-gray-800 text-base leading-relaxed">
          It’s designed to help property managers handle occupancy efficiently while offering guests a consistent and organized booking experience.
        </p>
      </div>
    </div>
  );
};

export default Roompopup;
